import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import FunFact from '../FunFact';
import PageHeading from '../PageHeading';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import { basepath } from '../../App';
import Footer from '../Footer';
import { Link } from 'react-router-dom';
import { SideMenu } from '../SideMenu';

export default function Vidro() {
  pageTitle('Vidro');

  const funfaceData = [
    {
      title: 'Usuários no Clube de Descontos',
      factNumber: '2.5M',
    },
    {
      title: 'Diárias de carro reserva liberadas todo o mês',
      factNumber: '15K',
    },
    {
      title: 'Novos segurados de vida todo mês',
      factNumber: '1.4K',
    },
    {
      title: 'Atendimentos de assistência residencial todo mês',
      factNumber: '33K',
    },
  ];
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
  
      <PageHeading
        title="Vidro"
        bgSrc={`${basepath}/img/gallery_images/vidros/vidros_4.webp`}
        pageLinkText="Vidro"
      />
      
      <SideMenu />

      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-7 mb-3">
            <SectionHeading
              title="Assistência sobre medida"
              subtitle="Sobre a assistência"
            >
              <Spacing lg="30" md="20" />
              <p className="text-justify cs-m0">Aqui seu associado possui a comodidade para a troca de vidros com qualidade, melhor preço e assistência. Possuímos cobertura BÁSICA, COMPLETA E PLUS, para quatro tipos de veículo: “Passeio Nacional”, “Passeio Importado”, “Van” e “Caminhão”. Somos parceiros da Autoglass e das melhores redes credenciadas do Brasil.</p>
              <Spacing lg="30" md="30" />
              <p className="text-justify cs-m0">Parceiros de confiança; Agilidade no atendimento; Serviços qualificados; Ampla cobertura; Melhor custo-benefício.</p>
              <Spacing lg="30" md="30" />
              <Link to={`${basepath}/cliente/VForm`}>
                <button className="fade-in cs-btn cs-style1 cs-type1" type='button' onClick={null}>
                    <span>Solicite agora</span>
                </button>
              </Link>
              <Spacing lg="25" md="40" />
            </SectionHeading>
          </Div>
          <Div className="col-lg-5 offset-xl-2 mb-3">
            <img
              src={`${basepath}/img/gallery_images/vidros/vidros_1.webp`}
              alt="About"
              className="w-100 h-100 object-fit-cover cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="hide_on_mobile col-lg-7">
            <img
              src={`${basepath}/img/gallery_images/vidros/vidros_2.webp`}
              alt="About"
              className="w-100 h-100 object-fit-cover cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="hide_on_mobile col-lg-5">
            <img
              src={`${basepath}/img/gallery_images/vidros/vidros_3.webp`}
              alt="About"
              className="w-100 h-100 object-fit-cover cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
        </Div>
      </Div>
      <Spacing lg="75" md="55" />

      <Div className="container">
        <FunFact
          title="Nossos numeros"
          subtitle="Conquistar um novo associado é muito bom,
          fidelizá-lo é muito melhor!"
          data={funfaceData}
        />
      </Div>

      <Spacing lg="100" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-image_layer cs-style1 h-100">
              <Div className="cs-image_layer_in h-100">
                <img
                  src={`${basepath}/img/gallery_images/gabi.webp`}
                  alt="About"
                  className="w-100 h-100 object-fit-cover cs-radius_15"
                />
              </Div>
            </Div>
            <Spacing lg="0" md="40" />
          </Div>
          <Div className="col-xl-5 offset-xl-1 col-lg-6">
            <SectionHeading
              title="Por quê nos escolher:"
              subtitle="Por que nos escolher"
            >
              <Spacing lg="30" md="20" />
              <p className="text-justify cs-m0">Empresa especializada em oferecer serviços assistenciais e programa de benefícios para pessoas, empresas e Entidades de Autogestão no Brasil.</p>
              <Spacing lg="15" md="15" />
              <p className="text-justify cs-m0">Nossa missão é tornar a vida mais fácil, oferecendo serviços de excelência agregado aos nossos valores. "Não se preocupe, seu problema está em nossas mãos.</p>
              <Spacing lg="30" md="30" />
              <p className='text-justify'><strong>Missão: </strong>Nossa missão é tornar a vida mais fácil, oferecendo serviços de excelência agregado aos nossos valores.</p>
              <p className='text-justify'><strong>Visão: </strong>Ser a empresa de benefícios mais amada do Brasil</p>
              <p className='text-justify'><strong>Nossos valores: </strong>Honestidade: Agimos com coerência e verdade, Inovação: Gerar e implementar novas ideias, Lealdade: Manter a lealdade à empresa e seus interesses, Responsabilidade: Aceitamos as consequências de nossas ações, Confiabilidade: Mantemos sempre nossas promessas</p>
              <Div className="cs-separator cs-accent_bg"></Div>
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="0" />
            </SectionHeading>
          </Div>
        </Div>
      </Div>

      <Spacing lg="150" md="80" />
      <Div className="container">
        <Cta
          title="Conquistar um novo associado é muito bom, fidelizá-lo é muito melhor!"
          btnText="Solicitar serviço!"
          btnLink={`${basepath}/cliente/VForm`}
        />
      </Div>

      <Footer />
    </>
  );
}
